export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Alle Kurse',
        to: '/dashboard',
        icon: 'cil-home',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Kursarten']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'VKU',
        to: '/course/vku',
        icon: 'cil-car-alt'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'VKU am Abend',
        to: '/course/vku-abend',
        icon: 'cil-car-alt'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'VKU Intensivkurs',
        to: '/course/vku-intensivkurs',
        icon: 'cil-car-alt'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Motorrad',
        to: '/course/moto/0',
        icon: 'cil-bike'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Motorradkurs 1',
        to: '/course/moto/2',
        icon: 'cil-bike'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Motorradkurs 2',
        to: '/course/moto/4',
        icon: 'cil-bike'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Motorradkurs 3',
        to: '/course/moto/3',
        icon: 'cil-bike'
      },
    ]
  }
]
